import { useEffect, useState } from 'react';
import { api, mensajeDe, type TorneoAdmin } from '../../services/api';
import { alTocar, ir } from '../../components/ruta';
import { Aviso, Boton, Cargando, Tarjeta, Titulo, Vacio } from '../../components/ui';
import { rangoDeFechas } from '../../nucleo/fechas';
import { FormTorneo } from './FormTorneo';

export const ETIQUETA_ESTADO = {
  borrador: { texto: 'Borrador', clase: 'border-(--color-alerta) text-(--color-alerta)' },
  publicado: { texto: 'Publicado', clase: 'border-(--color-acento) text-(--color-acento)' },
  terminado: { texto: 'Terminado', clase: 'border-(--color-borde) text-(--color-apagado)' },
} as const;

export function ListaTorneos() {
  const [torneos, setTorneos] = useState<TorneoAdmin[] | null>(null);
  const [error, setError] = useState('');
  const [creando, setCreando] = useState(false);

  useEffect(() => {
    api.torneos().then(
      (r) => {
        setTorneos(r.torneos);
        // Sin torneos, lo único que se puede hacer es crear uno: se abre solo.
        if (r.torneos.length === 0) setCreando(true);
      },
      (e) => setError(mensajeDe(e)),
    );
  }, []);

  if (error) return <Aviso tono="error">{error}</Aviso>;
  if (!torneos) return <Cargando />;

  return (
    <>
      {creando ? (
        <Tarjeta>
          <Titulo extra="nace en borrador: nadie lo ve hasta que lo publiques">Nuevo torneo</Titulo>
          <FormTorneo
            textoBoton="Crear torneo"
            alGuardar={async (d) => {
              const r = await api.crearTorneo(d);
              ir(`/admin/t/${r.torneo.id}`);
            }}
            alCancelar={torneos.length > 0 ? () => setCreando(false) : undefined}
          />
        </Tarjeta>
      ) : (
        <Boton onClick={() => setCreando(true)}>+ Nuevo torneo</Boton>
      )}

      <Tarjeta>
        <Titulo>Torneos</Titulo>
        {torneos.length === 0 && <Vacio>Todavía no hay torneos.</Vacio>}
        <ul className="flex flex-col">
          {torneos.map((t) => (
            <li key={t.id} className="border-t border-(--color-borde) first:border-t-0">
              <a href={`/admin/t/${t.id}`} onClick={alTocar(`/admin/t/${t.id}`)} className="flex items-center gap-3 py-3">
                <span className="flex-1">
                  <span className="block font-semibold">{t.nombre}</span>
                  <span className="block text-sm text-(--color-apagado)">
                    {rangoDeFechas(t.fecha_desde, t.fecha_hasta)}
                    {t.sede ? ` · ${t.sede}` : ''}
                  </span>
                </span>
                <span className={`rounded-full border px-2 py-0.5 text-xs font-semibold ${ETIQUETA_ESTADO[t.estado].clase}`}>
                  {ETIQUETA_ESTADO[t.estado].texto}
                </span>
                <span className="text-xl text-(--color-apagado)">›</span>
              </a>
              <div className="mb-3 flex flex-wrap gap-2">
                {([...(t.control_canchas_activo !== 0 ? ['control' as const] : []), 'preparar'] as const).map(v => <a key={v} href={`/admin/t/${t.id}/${v}`} onClick={alTocar(`/admin/t/${t.id}/${v}`)} className="flex min-h-10 items-center rounded-lg border border-(--color-borde) px-3 text-sm font-semibold text-(--color-acento)">{v === 'control' ? 'Control de canchas' : 'Preparar torneo'}</a>)}
              </div>
            </li>
          ))}
        </ul>
      </Tarjeta>
    </>
  );
}
